/* ===========================
   AGREGADO ANA – INICIO
   Flechas manuales para slideshow (Prestige)
   =========================== */

(function () {
  function moveSlide(carouselEl, direction) {
    const slides = Array.from(carouselEl.querySelectorAll('.slideshow__slide'));
    if (!slides.length) return;

    let currentIndex = slides.findIndex((s) => s.classList.contains('is-selected'));
    if (currentIndex < 0) currentIndex = 0;

    const nextIndex =
      direction === 'next'
        ? (currentIndex + 1) % slides.length
        : (currentIndex - 1 + slides.length) % slides.length;

    slides[currentIndex].classList.remove('is-selected');
    slides[nextIndex].classList.add('is-selected');

    const nav = carouselEl.querySelector('carousel-navigation');
    if (nav) {
      const dots = Array.from(nav.querySelectorAll('button[aria-current]'));
      dots.forEach((b, i) =>
        b.setAttribute('aria-current', i === nextIndex ? 'true' : 'false')
      );
    }

    slides[nextIndex].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[data-carousel][data-dir]');
    if (!btn) return;

    const carouselId = btn.getAttribute('data-carousel');
    const dir = btn.getAttribute('data-dir');
    const carouselEl = document.getElementById(carouselId);
    if (!carouselEl) return;

    e.preventDefault();
    moveSlide(carouselEl, dir);
  });
})();

/* ===========================
   AGREGADO ANA – FIN
   =========================== */
